import React, { useRef, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseCommonTooltipLayer.module.scss'

import IconTooltip from '@Ui/images/myhouse/IconTooltip'
import IconClose15x15 from '@Root/ui/images/myhouse/IconClose15x15.svg'
import { handleNclick } from '@Helpers/nclick'

const cx = className.bind(style)

type Props = {
  title: string
  children?: React.ReactNode
  styleButton?: React.CSSProperties
  styleTooltip?: React.CSSProperties
  wrapClass?: string
  nclickOpen?: string
}

// MyhouseTooltipLayer 참조.
const MyhouseCommonTooltipLayer: React.FC<Props> = ({ wrapClass, title, children, styleButton, styleTooltip, nclickOpen }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const tooltipLayer = useRef(null)
  const tooltipButton = useRef(null)

  const handleTooltipToggle = (event: React.SyntheticEvent) => {
    if (isOpen) {
      handleTooltipClose()
    } else {
      nclickOpen && handleNclick(nclickOpen, event)
      setIsOpen(true)
      document.addEventListener('mousedown', handleClickOutside)
    }
  }

  const handleTooltipClose = () => {
    setIsOpen(false)
    document.removeEventListener('mousedown', handleClickOutside)
  }

  const handleClickOutside = (event: any) => {
    let ele = event.target
    while (true) {
      if (ele === tooltipLayer.current || ele === tooltipButton.current) {
        break
      } else if (ele.id === 'wrap' || ele.nodeName.toUpperCase() === 'BODY') {
        handleTooltipClose()
        break
      }
      ele = ele.parentNode
    }
  }

  return (
    <div className={cx('article', wrapClass)}>
      <button ref={tooltipButton} type="button" style={styleButton} className={cx('button')} onClick={handleTooltipToggle}>
        <IconTooltip width="20" height="20" fill="#9da9bf" stroke="#9da9bf" />
        <span className={'blind'}>도움말</span>
      </button>
      {isOpen && (
        <div className={cx('tooltip')} style={styleTooltip}>
          <div className={cx('inner')}>
            {title && <strong className={cx('title')}>{title}</strong>}
            <div className={cx('text')}>{children}</div>
            <button type="button" className={cx('close')}>
              <IconClose15x15 />
              <span className={'blind'}>닫기</span>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default MyhouseCommonTooltipLayer
